export default function lt(length) {
  // Need to pass in a length so that we can display message
  // Otherwise, the browser will just stop adding characters.
  return (value = '', { maxLength, specialChars = true, string = true, locale = {} }) => {
    const max = length || maxLength;

    let overWriteValue = null || value;

    if (!specialChars) {
      const special = /[!@#$%^&*(),.?":{}|<>]/g;

      overWriteValue = value.toString().replace(special, '');
    }

    if (string && String(overWriteValue).length > max) {
      return locale.maxLength || `Max ${maxLength} characters`;
    }

    if (!string && overWriteValue.length > max) {
      return locale.maxLength || `Max ${maxLength} characters`;
    }

    return null;
  };
}
